import { FC } from 'react';
import { Box, Center, Stack } from '@chakra-ui/react';
import { Pagination } from '../../components/pagination/pagination';
import { UserSearchEmptyResult } from '../../components/user-search/user-search-empty-result';
import { UserSearchResultsSummary } from '../../components/user-search/user-search-results-summary';
import { UsersTable } from '../../components/users-table/users-table';
import { TreatyUserFragment } from '../../graphql/generated';
import {
  Role,
  TreatyDetailsFragment,
  TreatyUsersSearch,
} from '../../graphql/generated';

type UserResultsProps = {
  treatyUsers: {
    count: number;
    users: TreatyUserFragment[];
  };
  roles: Role[];
  treaties: TreatyDetailsFragment[];
  searchParams: TreatyUsersSearch;
  currentPage: number;
  pageSize: number;
  setPage: (page: string) => void;
  startTimedPolling: () => void;
};

export const UserResults: FC<UserResultsProps> = ({
  treatyUsers,
  roles,
  treaties,
  searchParams,
  currentPage,
  pageSize,
  setPage,
  startTimedPolling,
}) => {
  const handlePageChange = (page: number) => {
    setPage(String(page));
  };

  const total = treatyUsers.count;
  const isMultiplePages = total > pageSize;

  return (
    <Box py={8} data-testid="user-results">
      {total === 0 && (
        <Center height="50vh">
          <UserSearchEmptyResult
            name={searchParams.name}
            userType={searchParams.userType}
          />
        </Center>
      )}

      {total > 0 && (
        <Stack>
          <UserSearchResultsSummary
            name={searchParams.name}
            total={total}
            currentPage={currentPage}
            pageSize={pageSize}
          />

          <UsersTable
            users={treatyUsers.users}
            roles={roles}
            treaties={treaties}
            startTimedPolling={startTimedPolling}
            selectedRoles={searchParams.roles || []}
          />
        </Stack>
      )}

      {isMultiplePages && (
        <Pagination
          total={total}
          current={currentPage}
          pageSize={pageSize}
          onChange={handlePageChange}
          data-testid="pagination-controls"
        />
      )}
    </Box>
  );
};
